const NotFoundPage = () => { 
    return(
        <div className="flex items-center justify-center h-screen bg-white">
            <div className="text-center">
                <h1 className="text-6xl font-bold text-gray-800">404</h1>
                <p className="mt-4 text-2xl text-gray-600">Page Not Found</p>
                <p className="mt-2 text-gray-500">Sorry, the page you’re looking for doesn’t exist.</p>
                <a
                href="/"
                className="mt-6 inline-block px-6 py-2 text-white bg-blue-500 hover:bg-blue-600 rounded-md"
                >
                Go Home
                </a>
            </div>
        </div>
    );
}

export default NotFoundPage;